export default __webpack_public_path__ + "static/media/slider02.e1993c1f.jpg";